import { render, staticRenderFns } from "./RegexTester.vue?vue&type=template&id=2dc1f586&scoped=true"
import script from "./RegexTester.vue?vue&type=script&lang=js"
export * from "./RegexTester.vue?vue&type=script&lang=js"
import style0 from "./RegexTester.vue?vue&type=style&index=0&id=2dc1f586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1f586",
  null
  
)

export default component.exports